import { Fallback } from '../styled';
export function AvatarLetter(props) {
    const { children, className } = props;
    return <Fallback className={className}>{children}</Fallback>;
}
